import { render, staticRenderFns } from "./ia-insight-card.vue?vue&type=template&id=6644428a&scoped=true&"
import script from "./ia-insight-card.vue?vue&type=script&lang=js&"
export * from "./ia-insight-card.vue?vue&type=script&lang=js&"
import style0 from "./ia-insight-card.vue?vue&type=style&index=0&id=6644428a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6644428a",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6644428a')) {
      api.createRecord('6644428a', component.options)
    } else {
      api.reload('6644428a', component.options)
    }
    module.hot.accept("./ia-insight-card.vue?vue&type=template&id=6644428a&scoped=true&", function () {
      api.rerender('6644428a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/ia-insight-card/ia-insight-card.vue"
export default component.exports